<template>
  <div class="row">
    <div class="col-12 col-sm-12 col-md-4 col-lg-3">
      <NavigationComponent/>
    </div>
    <div class="col-12 col-sm-12 col-md-8 col-lg-9">
      <router-view/>
    </div>
  </div>
</template>

<script>
import NavigationComponent from '../components/shared/Navigation.vue';
export default {
    components: {
      NavigationComponent
    },
}
</script>

<style>

</style>
